<template>
    <img
        :src="require('../assets/logo.jpg')"
        contain
        :height="height"
    >
</template>
<script>
export default {
    props: {
        height: {type: Number, default: 50},
    }
}
</script>
